import React, { useEffect, useState } from "react";

import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";

import { useLocation } from "react-router-dom";
import { getOddForEntity } from "./casinoConstant";

export default function AndarBahar2({ casino, shortName }) {
  // const GAME_ID = "ABJ";,
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];

  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);
  const casinoData = useQuery("getCasinoOdds", () => getCasinoOddsAPI("abj"), {
    refetchInterval: 800,
  });

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(
        () => {
          getPlExposure();
        },
        2000
      );
      return () => {
        clearInterval(
          interval
        );
      };
    }
  }, [casinoData?.data?.response?.marketId]);


  const casinoCardMap = (_) => {
    let cardMap = {
      ab2:7
      
    }
    
  }

  
  
  return (
    <div className="container">
      <div className="row margin0">
        <div className="col-12 padding0">
          <div className="game-header">
            <span>Andar Bahar 2</span>
            <span>
              {" "}
              Round : {casinoData?.data?.response?.marketId}{" "}
              <button className="rules-btn btn btn-warning btn-sm">
                Rules
              </button>
            </span>
          </div>
          <div className="row margin0">
            <div className="col-12 padding0" style={{ position: "relative" }}>
              <iframe
                src="https://dfii.live/casino?id=abj"
                height={400}
                width="100%"
                scrolling="auto"
                className="liveStr"
              />
              {    casinoData?.data?.response?.cards && casinoData?.data?.response?.cards.length > 0 && (
        <div
          _ngcontent-ng-c1798067373=""
          className="casino-video-cards ng-tns-c1798067373-0 ng-star-inserted"
        >
          <div
            _ngcontent-ng-c1798067373=""
            className="ab-cards-container ng-tns-c1798067373-0"
          >
            <div
              _ngcontent-ng-c1798067373=""
              className="row row5 align-items-center ng-tns-c1798067373-0"
            >
              <div
                _ngcontent-ng-c1798067373=""
                className="col-1 ng-tns-c1798067373-0"
              >
                <div
                  _ngcontent-ng-c1798067373=""
                  className="row row5 ng-tns-c1798067373-0"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="col-12 ng-tns-c1798067373-0"
                  >
                    <b
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-0"
                    >
                      A
                    </b>
                  </div>
                </div>
                <div
                  _ngcontent-ng-c1798067373=""
                  className="row row5 ng-tns-c1798067373-0"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="col-12 ng-tns-c1798067373-0"
                  >
                    <b
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-0"
                    >
                      B
                    </b>
                  </div>
                </div>
              </div>
              <div
                _ngcontent-ng-c1798067373=""
                className="col-2 ng-tns-c1798067373-0"
              >
                <div
                  _ngcontent-ng-c1798067373=""
                  className="flip-card ng-tns-c1798067373-0"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="flip-card-inner ng-tns-c1798067373-0"
                  >
                    <div
                      _ngcontent-ng-c1798067373=""
                      className="flip-card-front ng-tns-c1798067373-0"
                    >
                      <img
                        _ngcontent-ng-c1798067373=""
                        className="ng-tns-c1798067373-0"
                        src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${casinoData?.data?.response?.cards[0][0]
                          }.jpg`}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                _ngcontent-ng-c1798067373=""
                className="col-9 ng-tns-c1798067373-0 ng-star-inserted"
              >
                <div
                  _ngcontent-ng-c1798067373=""
                  className="row row5 mb-1 ng-tns-c1798067373-0"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="col-lg-10 col-9 ng-tns-c1798067373-0"
                  >
                    <div
                      _ngcontent-ng-c1798067373=""
                      className="casino-result-cards col-lg-12 ng-tns-c1798067373-0"
                    >
                      <div
                        _ngcontent-ng-c1798067373=""
                        className="casino-result-cardimg ng-tns-c1798067373-0"
                      >
                        <div
                          _ngcontent-ng-c1798067373=""
                          className="andar-bhar2-cards-slider ng-tns-c1798067373-0"
                        >
                          {/**/}
                          {/**/}
                          {/**/}
                          {/**/}
                          <div
                            _ngcontent-ng-c1798067373=""
                            className="draggable ng-tns-c1798067373-0"
                          >
                            {casinoData?.data?.response?.cards[1]?.map(
                              (item) =>
                                item != "1" && (
                                  <img
                                    _ngcontent-ng-c1798067373=""
                                    onerror="this.src='assets/images/cards/1.jpg'"
                                    className="ng-tns-c1798067373-0"
                                    src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                  />
                                )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  _ngcontent-ng-c1798067373=""
                  className="row row5 mb-1 ng-tns-c1798067373-0"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="col-lg-10 col-9 ng-tns-c1798067373-0"
                  >
                    <div
                      _ngcontent-ng-c1798067373=""
                      className="casino-result-cards col-lg-12 ng-tns-c1798067373-0"
                    >
                      <div
                        _ngcontent-ng-c1798067373=""
                        className="casino-result-cardimg ng-tns-c1798067373-0"
                      >
                        <div
                          _ngcontent-ng-c1798067373=""
                          className="andar-bhar2-cards-slider ng-tns-c1798067373-0"
                        >
                          {/**/}
                          {/**/}
                          {/**/}
                          {/**/}
                          <div
                            _ngcontent-ng-c1798067373=""
                            className="draggable ng-tns-c1798067373-0"
                          >
                            {casinoData?.data?.response?.cards[2]?.map(
                              (item) =>
                                item != "1" && (
                                  <img
                                    _ngcontent-ng-c1798067373=""
                                    onerror="this.src='assets/images/cards/1.jpg'"
                                    className="ng-tns-c1798067373-0"
                                    src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                  />
                                )
                            )}
                            {/**/}
                            {/**/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/**/}
            </div>
          </div>
        </div>
        
      )}
              {/* <div className="flipclock">
                <span className="flipclock-t1 fold">
                  {casinoData?.data?.response?.autoTime}
                </span>
              </div> */}
              
            </div>
          </div>
          <div className="row andarbahar-module mr-left-right">
            <div className="row mr-left-right lucky7-main">
              <div className="col-xs-12 col-sm-2 col-md-2">
                <div
                  className="ab2-text"
                  style={{ color: "rgb(0, 0, 0)", fontWeight: 700 }}
                >
                  Andar
                </div>
              </div>
              <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3">
                <div
                  className="col-12 ab2-text ab2-btn-background"
                  style={{ padding: 0, position: "relative" }}
                >
                  1st Bet<span>{getOddForEntity("1st bet", casinoData)}</span>
                  {casinoData?.data?.response?.autoTime < 5 && (
                    <div className="susb-bhav">
                      <img
                        src="https://hrx99.com/images/cards/padlock.png"
                        alt="lock"
                      />
                    </div>
                  )}
                </div>
                
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3">
                <div
                  className="col-12 ab2-text ab2-btn-background"
                  style={{ padding: 0, position: "relative" }}
                >
                  2nd Bet<span>0.95</span>
                  {casinoData?.data?.response?.autoTime < 5 && (
                    <div className="susb-bhav">
                      <img src="https://hrx99.com/images/cards/padlock.png" />
                    </div>
                  )}
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3">
                <div
                  className="col-12 ab2-text ab2-btn-background"
                  style={{ padding: 0, position: "relative" }}
                >
                  3st Bet<span>0.95</span>
                  {casinoData?.data?.response?.autoTime < 5 && (
                    <div className="susb-bhav">
                      <img src="https://hrx99.com/images/cards/padlock.png" />
                    </div>
                  )}
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-xs-12 col-sm-2 col-md-2"
                style={{ textAlign: "center" }}
              >
                <div
                  className="ab2-text"
                  style={{ color: "rgb(0, 0, 0)", fontWeight: 700 }}
                >
                  Bahar
                </div>
              </div>
              <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3">
                <div
                  className="col-12 ab2-text ab2-btn-background"
                  style={{ padding: 0, position: "relative" }}
                >
                  1st Bet<span>0.95</span>
                  {casinoData?.data?.response?.autoTime < 5 && (
                    <div className="susb-bhav">
                      <img src="https://hrx99.com/images/cards/padlock.png" />
                    </div>
                  )}
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3">
                <div
                  className="col-12 ab2-text ab2-btn-background"
                  style={{ padding: 0, position: "relative" }}
                >
                  2st Bet<span>0.95</span>
                  {casinoData?.data?.response?.autoTime < 5 && (
                    <div className="susb-bhav">
                      <img src="https://hrx99.com/images/cards/padlock.png" />
                    </div>
                  )}
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3">
                <div
                  className="col-12 ab2-text ab2-btn-background"
                  style={{ padding: 0, position: "relative" }}
                >
                  3rd Bet<span>0.95</span>
                  {casinoData?.data?.response?.autoTime < 5 && (
                    <div className="susb-bhav">
                      <img src="https://hrx99.com/images/cards/padlock.png" />
                    </div>
                  )}
                </div>
                <div style={{ color: "red" }}> 0.00 </div>
              </div>
            </div>
            <div className="row mr-left-right lucky7-main">
              <div className="col-6 col-md-3 lucky7-main-bhav">
                <span className="casino-profit-text"> 0.83 </span>
                <div className="col-12 lucky7-bhav">
                  <button>
                    <div className="susb-bhav">
                      <img src="https://hrx99.com/images/cards/padlock.png" />
                    </div>
                    ODD
                  </button>
                </div>
                <div style={{ color: "red" }}>0.00</div>
              </div>
              <div className="col-6 col-md-3 lucky7-main-bhav">
                <span className="col-12 casino-profit-text"> 1.12 </span>
                <div className="col-12 lucky7-bhav">
                  <button>
                    <div className="susb-bhav">
                      <img src="https://hrx99.com/images/cards/padlock.png" />
                    </div>
                    EVEN
                  </button>
                </div>
                <div style={{ color: "red" }}> 0.00 </div>
              </div>
              <div
                className="col-12 col-md-6 lucky7-main-bhav"
                style={{ display: "flex" }}
              >
                <div className="col-3 lucky7-main-bhav">
                  <span className="casino-profit-text"> 2.83 </span>
                  <div className="col-12 lucky7-bhav">
                    <button>
                      <div className="susb-bhav">
                        <img src="https://hrx99.com/images/cards/padlock.png" />
                      </div>
                      <img
                        src="/images/cards/ace-of-spades.png"
                        className="tpatti-img-height"
                      />
                    </button>
                  </div>
                  <div style={{ color: "red" }}>0.00</div>
                </div>
                <div className="col-3 lucky7-main-bhav">
                  <span className="casino-profit-text">2.83</span>
                  <div className="col-12 lucky7-bhav">
                    <button>
                      <div className="susb-bhav">
                        <img src="https://hrx99.com/images/cards/padlock.png" />
                      </div>
                      <img
                        src="/images/cards/clover-ace.png"
                        className="tpatti-img-height"
                      />
                    </button>
                  </div>
                  <div style={{ color: "red" }}>0.00</div>
                </div>
                <div className="col-3 col-md-3 lucky7-main-bhav">
                  <span className="col-12 col-md-12 casino-profit-text">
                    {" "}
                    2.83{" "}
                  </span>
                  <div className="col-12 col-md-12 lucky7-bhav">
                    <button>
                      <div className="susb-bhav">
                        <img src="https://hrx99.com/images/cards/padlock.png" />
                      </div>
                      <img
                        src="/images/cards/heart.png"
                        className="tpatti-img-height"
                      />
                    </button>
                  </div>
                  <div style={{ color: "red" }}> 0.00 </div>
                </div>
                <div className="col-3 col-md-3 lucky7-main-bhav">
                  <span className="col-12 col-md-12 casino-profit-text">
                    2.83{" "}
                  </span>
                  <div className="col-12 col-md-12 lucky7-bhav">
                    <button>
                      <div className="susb-bhav">
                        <img src="https://hrx99.com/images/cards/padlock.png" />
                      </div>
                      <img
                        src="/images/cards/diamond.png"
                        className="tpatti-img-height"
                      />
                    </button>
                  </div>
                  <div style={{ color: "red" }}> 0.00 </div>
                </div>
              </div>
            </div>
            <div className="row mr-left-right lucky7-main">
              <div className="col-12 col-md-12 lucky7-main-bhav">
                <span className="casino-profit-text">11</span>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/1.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/2.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/3.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/4.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/5.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/6.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/7.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/8.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/9.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/10.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/11.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/12.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
              <div
                className="col-2"
                style={{ padding: 0, position: "relative" }}
              >
                <div className="susb-bhav">
                  <img src="https://hrx99.com/images/cards/padlock.png" />
                </div>
                <div className="lucky7-main-bhav-card">
                  <img src="/images/cards/13.jpg" style={{ height: 50 }} />
                </div>
                <div style={{ color: "red" }}>0.00 </div>
              </div>
            </div>
          </div>
          <div className="game-header">
            <span>Last Result</span>
            <span>
              <a
                title="View All"
                href="/user/statement"
                style={{ color: "rgb(255, 255, 255)" }}
              >
                View All
              </a>
            </span>
          </div>
          <div className="col-md-12 result-section" />
        </div>
      </div>
    </div>
    
  );
}
